import Component from './component';
import { deleteItem } from './actions';

export default (connect) => connect(
  ({ dialogs }) => ({ dialogs }),
  { deleteItem },
)(Component);
